module.exports = __webpack_public_path__ + "img/mobile-comingsoon.9841537a.png";